import { useApp } from '../../context/AppContext';
import { ACHIEVEMENTS, TIER_COLORS } from '../../data/actions';

export function AchievementPopup() {
  const { showAchievementPopup } = useApp();

  if (!showAchievementPopup) return null;

  const achievement = ACHIEVEMENTS.find(a => a.id === showAchievementPopup.id);
  if (!achievement) return null;

  const tierStyle = TIER_COLORS[achievement.tier];

  return (
    <div
      role="alert"
      aria-live="assertive"
      style={{
        position: "fixed",
        bottom: "2rem",
        left: "50%",
        transform: "translateX(-50%)",
        background: "#0d1f10",
        border: `1px solid ${tierStyle.color}40`,
        borderRadius: "16px",
        padding: "1rem 1.25rem",
        zIndex: 10000,
        boxShadow: `0 8px 32px ${tierStyle.color}30`,
        animation: "fadeUp 0.4s ease",
        display: "flex",
        alignItems: "center",
        gap: "0.75rem",
        maxWidth: "90vw",
      }}
    >
      <div
        style={{
          width: "48px",
          height: "48px",
          borderRadius: "50%",
          background: tierStyle.bg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.5rem",
          flexShrink: 0,
        }}
      >
        {achievement.icon}
      </div>
      <div>
        <div style={{ fontSize: "0.65rem", letterSpacing: "0.15em", color: tierStyle.color, textTransform: "uppercase" }}>
          Achievement Unlocked!
        </div>
        <div style={{ fontSize: "1rem", fontWeight: "bold", color: "#f0fdf4", marginTop: "0.15rem" }}>
          {achievement.title}
        </div>
        <div style={{ fontSize: "0.78rem", color: "#9ca3af", marginTop: "0.1rem" }}>
          {achievement.description}
        </div>
      </div>
    </div>
  );
}

export function AchievementList() {
  const { unlockedAchievements } = useApp();

  if (unlockedAchievements.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "2rem", color: "#6b7280" }}>
        <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>🏆</div>
        <div>Complete actions to unlock achievements!</div>
      </div>
    );
  }

  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "0.75rem" }}>
      {ACHIEVEMENTS.map(achievement => {
        const isUnlocked = unlockedAchievements.includes(achievement.id);
        const tierStyle = TIER_COLORS[achievement.tier];

        return (
          <div
            key={achievement.id}
            style={{
              background: isUnlocked ? tierStyle.bg : "rgba(255,255,255,0.02)",
              border: `1px solid ${isUnlocked ? tierStyle.color + "40" : "rgba(255,255,255,0.06)"}`,
              borderRadius: "12px",
              padding: "0.85rem",
              opacity: isUnlocked ? 1 : 0.5,
              transition: "all 0.3s",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "0.6rem", marginBottom: "0.4rem" }}>
              <span style={{ fontSize: "1.3rem" }}>{isUnlocked ? achievement.icon : "🔒"}</span>
              <span style={{ fontSize: "0.85rem", fontWeight: 600, color: isUnlocked ? "#f0fdf4" : "#6b7280" }}>
                {achievement.title}
              </span>
            </div>
            <div style={{ fontSize: "0.75rem", color: "#9ca3af" }}>
              {achievement.description}
            </div>
          </div>
        );
      })}
    </div>
  );
}
